<template>
  <div>
    <h6 class="text-left table-header">
      {{ header | i18n }}
    </h6>
    <Table
      :columns="columns"
      :rows="items"
      :pagination="false"
      :on-row-click="rowClick"
      tableName="ticketsDashboardTable"
    />
  </div>
</template>

<script>
import Table from '../../common/table';

export default {
  name: 'LatestOrders',
  components: { Table },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    header: {
      type: String,
      default: ''
    },
    rowClick: {
      type: Function,
      default: () => {}
    }
  },
  data: function() {
    return {
      columns: [
        { key: '1', field: 'title', title: this.$translate('title'), align: 'left' },
        { key: '2', field: 'template', title: this.$translate('template'), align: 'left' },
        {
          key: '3',
          field: 'status',
          title: this.$translate('status'),
          align: 'center',
          renderBodyCell: ({ row }, h) => {
            return <span class={`badge status-badge badge-${row.statusColor}`}> {this.$translate(row.status)} </span>;
          }
        },
        { key: '4', field: 'teamName', title: this.$translate('Team'), align: 'left' },
        { key: '5', field: 'userName', title: this.$translate('User'), align: 'left' },
        { key: '6', field: 'updatedAt', title: this.$translate('Updated'), align: 'left' }
      ]
    };
  },
};
</script>

<style lang="scss">
.case-table {
  tr {
    cursor: pointer;
  }
}

.badge {
  padding: 0.25em 0.4em !important;
}

.table-header {
  color: #5f5f5f !important;
  font-size: 1.3rem !important;
  font-weight: 300;
  margin-bottom: 20px;
  margin-top: 10px;
}
</style>
